/**
 * Opens a popup window to authenticate with Tiltify, and returns the user ID.
 */
export function openTiltifyOAuthPopup(
  setUser = (user) => {
    console.warn('setUser not handled', user);
  }
) {
  //https://tiltify.com/+warchant/relay-test
  const url = new URL('https://v5api.tiltify.com/oauth/authorize');
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('client_id', import.meta.env.VITE_TILTIFY_CLIENT_ID);
  url.searchParams.set(
    'redirect_uri',
    encodeURI(import.meta.env.VITE_TILTIFY_REDIRECT_URI)
  );
  url.searchParams.set('scope', 'public');
  const origin = new URL(import.meta.env.VITE_TILTIFY_REDIRECT_URI).origin;
  //&scope=<scopes>`;
  const win = window.open(url.toString());
  win.focus();

  const handleEvent = (event) => {
    if (event.origin !== origin) return;
    try {
      const data = JSON.parse(event.data);
      if (data.id) {
        setUser(data);
        window.removeEventListener('message', handleEvent);
      }
    } catch (err) {
      console.error(err);
    }
  };

  window.addEventListener('message', handleEvent);
}
